var _excluded = ["name", "isSelected", "isDisabled", "src", "onClick", "badge", "badgeColor", "data-testid", "bgColor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useState } from 'react';
import { forwardRef, useTestId } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { _BaseIcon, Box, iconColorMapping } from '../../internal';
import { Image } from '../../media';
import { BrandSymbol } from '../BrandSymbol';
import { getAvatarInitials, isBrandSymbol } from './avatar.utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Avatar = forwardRef((_ref, ref) => {
  var {
    name,
    isSelected,
    isDisabled,
    src,
    onClick,
    badge,
    badgeColor,
    'data-testid': dataTestId = 'avatar',
    bgColor
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [isImageError, setIsImageError] = useState(false);
  var isSquare = props.variant === 'square';
  var styles = useMultiStyleConfig('Avatar', _objectSpread({
    onClick,
    bgColor,
    isDisabled
  }, props));
  var badgeIconColor = badge === 'verified' && 'brand' || badgeColor;
  var circleImageProps = {
    borderRadius: 'full'
  };
  var squareImageProps = {
    borderRadius: 'm',
    aspectRatio: '1 / 1'
  };
  var conditionalImageProps = isSquare ? squareImageProps : circleImageProps;
  var getTestId = useTestId(dataTestId);
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
    "data-component": "Avatar"
  }, props), getTestId()), {}, {
    __css: styles['container'],
    ref: ref,
    children: /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread(_objectSpread({
      "aria-disabled": isDisabled,
      "data-selected": isSelected || null
    }, getTestId('content')), !isDisabled && onClick && {
      role: 'button',
      tabIndex: 0,
      onClick
    }), {}, {
      __css: styles['avatar'],
      children: [src && !isImageError ? /*#__PURE__*/_jsx(Box, {
        __css: styles['image'],
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({
          src: src,
          alt: name,
          onError: () => setIsImageError(true),
          isDisabled: isDisabled
        }, getTestId('image')), conditionalImageProps))
      }) : /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
        __css: styles['initials']
      }, getTestId('initials')), {}, {
        children: getAvatarInitials(name, props.size === 'extra-small')
      })), badge && /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
        __css: styles['badge']
      }, getTestId('badge')), {}, {
        children: isBrandSymbol(badge) ? /*#__PURE__*/_jsx(BrandSymbol, {
          type: badge,
          size: props.size === 'small' ? 'extra-small' : 'small',
          isDisabled: isDisabled
        }) : /*#__PURE__*/_jsx(_BaseIcon, {
          type: badge,
          size: props.size === 'small' ? 'extra-small' : 'small',
          color: iconColorMapping[badgeIconColor !== null && badgeIconColor !== void 0 ? badgeIconColor : 'default'],
          isDisabled: isDisabled
        })
      }))]
    }))
  }));
});
Avatar.displayName = 'Avatar';
//# sourceMappingURL=Avatar.js.map